/**
 * isEmpty - returns true if given data is empty
 *
 * @param {*} data
 * @return {*}  {boolean}
 *
 * @example
 * // returns true
 * isEmpty(null);
 *
 */
export var isEmpty = function (data) { return (typeof data === 'object' && data !== null
    ? !Object.keys(data).length
    : !data); };
//# sourceMappingURL=isEmpty.js.map